import { posthogClient } from '../posthog/posthog.service'
import { analytics } from './mixpanel.service'
import type { AnalyticsConfig } from './types'

/**
 * Initialize analytics (Mixpanel + PostHog dual-write) with environment configuration
 */
export const initializeAnalytics = (): void => {
  const posthogKey = import.meta.env.VITE_POSTHOG_KEY
  if (posthogKey) {
    posthogClient.init({
      apiKey: posthogKey,
      apiHost: import.meta.env.VITE_POSTHOG_HOST,
      debug: import.meta.env.DEV,
    })
  }

  const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN

  if (!mixpanelToken) {
    console.warn('VITE_MIXPANEL_TOKEN not found. Mixpanel will not be initialized.')
    return
  }

  const config: AnalyticsConfig = {
    token: mixpanelToken,
    debug: import.meta.env.DEV, // Enable debug mode in development
    trackAutomaticEvents: false, // We'll track events manually
    persistence: 'cookie', // Use cookies for cross-subdomain tracking
    secureCookie: window.location.protocol === 'https:',
    cookieDomain: '.taka.ai', // note the leading dot
    crossSubdomainCookie: true, // enable cross-subdomain tracking
    ignoreDnt: false, // Respect Do Not Track setting
  }

  analytics.init(config)
}

export { analytics }
